import { render, staticRenderFns } from "./PrinterCard.vue?vue&type=template&id=46353bce&scoped=true&"
import script from "./PrinterCard.vue?vue&type=script&lang=js&"
export * from "./PrinterCard.vue?vue&type=script&lang=js&"
import style0 from "./PrinterCard.vue?vue&type=style&index=0&id=46353bce&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46353bce",
  null
  
)

export default component.exports